import { apiClient, type CreateCustomerDto } from '@/libs/api'

export type CreateCustomerRequest = {
  tenantKey: string
  dto: CreateCustomerDto
}

export const createCustomer = async ({
  tenantKey,
  dto
}: CreateCustomerRequest) => {
  const { data, errors } = await apiClient
    ._tenant(tenantKey)
    .customers.$post({ body: dto })
  return { data, errors }
}
